import { useContext } from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { AuthContext, AuthProvider } from "./contexts/AuthContext"; // Import AuthContext
import RouteScrollToTop from "./helper/RouteScrollToTop";
import PhosphorIconInit from "./helper/PhosphorIconInit";
import HomePageOne from "./pages/HomePageOne";
import OrderTrack from "./pages/OrderTrack";
import ShopPage from "./pages/ShopPage";
import ProductDetailsOne from "./components/ProductDetailsOne";
import ProductDetailsTwo from "./components/ProductDetailsTwo";
import CategoryProducts from "./pages/CategoryProducts";
import ProductDetails from "./pages/ProductDetails";
import VendorProducts from "./pages/VendorProducts";
import CartPage from "./pages/CartPage";
import Account from "./components/LoginSignUp";
import Blog from "./components/Blog";
import BlogDetails from "./components/BlogDetails";
import Contact from "./components/Contact";
import CheckoutPage from "./pages/Checkout"; // For logged-in users
//import GuestCheckoutPage from "./pages/GuestCheckout"; // For guest users
import Products from "./pages/Products";
import LoginSignUpPage from "./pages/LoginSignUpPage";
import Wishlist from "./pages/Wishlist";
import ProtectedRoute from "./utils/ProtectedRoutes";
import PublicRoute from "./utils/PublicRoute";
import ProductSearchPage from "./pages/ProductSearchPage";
import HotDealsPage from "./pages/HotDealsPage";
import ReturnSuccessPage from "./pages/ReturnSuccessPage";
import ReturnCancel from "./pages/ReturnCancel";

import ContactUsPage from "./pages/ContactUsPage";
import MyAccountPage from "./pages/MyAccountPage";
import AddressBookPage from "./pages/AddressBookPage";
import AuthenticatedCheckout from "./pages/AuthenticatedCheckout";
import MyOrdersPage from "./pages/MyOrdersPage";
import OrderDetailsPage from "./pages/OrderDetailsPage";
import TrackOrderPage from "./pages/TrackOrderPage";
import FeaturedPage from "./pages/Collections/FeaturedPage";
import SalePage from "./pages/Collections/SalePage";
import PrivacyPolicyPage from "./pages/PrivacyPolicyPage";
import AboutUsPage from "./pages/AboutUsPage";
import TermsAndConditionsPage from "./pages/TermsAndConditionsPage";
import ReturnsAndRefundPolicyPage from "./pages/ReturnsAndRefundPolicyPage";
import FreeDeliveryPage from "./pages/Collections/FreeDeliveryPage";
import OrderSuccessPage from "./pages/OrderSuccessPage";
import CollectionHotDealsPage from "./pages/Collections/CollectionHotDealsPage";
import CollectionPage from "./pages/Collections/CollectionPage";
import PaymentVerificationPage from "./pages/PaymentVerificationPage";
function AppRoutes() {
  const { isAuthenticated } = useContext(AuthContext); // Access authentication state

  return (
    <Routes>
      <Route exact path="/" element={<HomePageOne />} />
      <Route exact path="/orders" element={<OrderTrack />} />
      {/* <Route exact path="/shop" element={<ShopPage />} /> */}
      <Route exact path="/product-details-one/:id" element={<ProductDetailsOne />} />
      <Route exact path="/product-details/:id" element={<ProductDetails />} />
      <Route exact path="/category-products/:id" element={<CategoryProducts />} />
      <Route exact path="/shop/:id" element={<VendorProducts />} />
      <Route exact path="/cart" element={<CartPage />} />
      <Route exact path="/login" element={<PublicRoute><LoginSignUpPage /></PublicRoute>} />
      <Route exact path="/blog" element={<Blog />} />
      <Route exact path="/blog-details" element={<BlogDetails />} />
      <Route exact path="/contact" element={<ContactUsPage />} />
      <Route exact path="/track-order" element={<TrackOrderPage />} />
      <Route exact path="/featured/:id" element={<FeaturedPage />} />
      <Route exact path="/sale/:id" element={<SalePage />} />
      <Route exact path="/free_delivery/:id" element={<FreeDeliveryPage />} />
      <Route exact path="/hotdeals/:id" element={<CollectionHotDealsPage />} />
      <Route exact path="/privacy-policy" element={<PrivacyPolicyPage />} />
      <Route exact path="/about-us" element={<AboutUsPage />} />
      <Route exact path="/terms-and-conditions" element={<TermsAndConditionsPage />} />
      <Route exact path="/return-policy" element={<ReturnsAndRefundPolicyPage />} />
      <Route exact path="/order-success" element={<OrderSuccessPage />} />
      <Route exact path="/payment-verification" element={<PaymentVerificationPage />} />

      {/* <Route exact path="/collection/:id" element={<CollectionPage />} /> */}


      {/* ✅ Serve Different Pages for Authenticated & Guest Users on /checkout */}
      <Route
        exact
        path="/checkout"
        element={isAuthenticated ? <AuthenticatedCheckout /> : <CheckoutPage />}
      />
      <Route exact path="/my-orders" element={<ProtectedRoute><MyOrdersPage /></ProtectedRoute>} />
      <Route exact path="/products" element={<Products />} />
      <Route exact path="/wishlist" element={<ProtectedRoute><Wishlist /></ProtectedRoute>} />
      <Route exact path="/search" element={<ProductSearchPage />} />
      <Route exact path="/hotdeals" element={<HotDealsPage />} />
      <Route exact path="/account" element={<ProtectedRoute><MyAccountPage /></ProtectedRoute>} />
      <Route exact path="/address-book" element={<ProtectedRoute><AddressBookPage /></ProtectedRoute>} />
      <Route exact path="/orderdetails/:id" element={<ProtectedRoute><OrderDetailsPage /></ProtectedRoute>} />

      {/* Payment & Order Processing */}
      <Route exact path="/returnSuccess" element={<ReturnSuccessPage />} />
      <Route exact path="/returnCanceled" element={<ReturnCancel />} />
      

      {/* Default Redirect for Unknown Routes */}
      <Route exact path="*" element={<HomePageOne />} />
    </Routes>
  );
}

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <RouteScrollToTop />
        <PhosphorIconInit />
        <AppRoutes />
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
